// Function date
    import functionsFiltres from '@/functions/filter.js'
    import functionsTris from '@/functions/tris.js'
    import params from '@/param/param.js'



    // Déclaration tableau réutilisable
        const mois = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
        const moisnumerique = new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12');
        const jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
        const jours_fr = new Array('Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche');
        const joursInput = new Array('dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi');
    
    // Déclaration functions
        const date = {
            date(date){
                var currentdate = ''
                
                if(date === ''){
                    currentdate = new Date();
                }else{
                    currentdate = new Date(date)
                }
                
                var annee = currentdate.getFullYear();
                var moi = currentdate.getMonth();
                var jour = currentdate.getDay();
                let j = currentdate.getDate()
                if(j < 10){
                    j = '0'+j
                }

                let maDate = {}

                maDate.date_fr = j + '/' + moisnumerique[moi] + '/' + annee
                maDate.date_en = annee + '-' + moisnumerique[moi] + '-' + j
                maDate.date_compa = annee + moisnumerique[moi] + j
                maDate.ecrit = jours[jour]+' '+j+' '+mois[moi]+' '+annee+'';

                maDate.annee = annee
                
                maDate.mois = mois[moi]
                maDate.moisnumerique = moisnumerique[moi]
                
                maDate.jour = jours[jour]
                maDate.journumerique = jour
                
                maDate.date = j
                maDate.datenumber = Number(j)

                maDate.time = currentdate.getHours()+" h "+currentdate.getMinutes()+" min "+currentdate.getSeconds()+" sec";
                maDate.timenumerique = currentdate.getHours() + ':' + currentdate.getMinutes() + ':' + currentdate.getSeconds()
                maDate.heure = currentdate.getHours()
                maDate.minute = currentdate.getMinutes()

                return maDate
            }, 

            getDateAnte(date, id) {
                let today = ''
                if(date != ''){
                    today = new Date(date);
                }else{
                    today = new Date();
                }
                const yesterday = new Date(today);
                yesterday.setDate(today.getDate() - id);
                return yesterday.toISOString().slice(0, 10); // Retourne la date au format YYYY-MM-DD
            },

            getFirstAndLastDayOfMonth: function(monthName, year, nbrMois, nbrAnnee) {
                let monMois = mois.indexOf(monthName) + 1
                if(Number(mois.indexOf(monthName)) + Number(nbrMois) < 0){
                    nbrAnnee = -1
                    monMois = 12 + (Number(mois.indexOf(monthName)) + Number(nbrMois))
                }else{
                    monMois = (Number(mois.indexOf(monthName)) + Number(nbrMois)) + 1
                }

                if(monMois < 10){
                    monMois = '0' + monMois
                }

                // Crée un objet Date avec le premier jour du mois et l'année donnés
                let firstDayOfMonth = new Date((Number(year) + nbrAnnee) + '-' + monMois + '-01');
                firstDayOfMonth = firstDayOfMonth.toISOString().slice(0, 10);
                
                // Obtient le dernier jour du mois en ajoutant 1 mois au premier jour du mois, puis en soustrayant 1 jour
                let lastDayOfMonth = new Date((Number(year) + nbrAnnee), moisnumerique[Number(monMois) - 1], 1);
                lastDayOfMonth = lastDayOfMonth.toISOString().slice(0, 10);
                return {
                    firstDay: firstDayOfMonth,
                    lastDay: lastDayOfMonth
                };
            },

            arrondiMinute(heure, min, arrondi){
                let minArrondies = Math.round((min) / arrondi) * arrondi
                if(minArrondies < 10){
                    return heure +':0'+ minArrondies
                }else if(minArrondies === 60){
                    return Number(heure + 1) + ":00"
                }else{
                    return heure + ':' + minArrondies
                }
            },

            conversionTime: function(time){
                let timeText = time.toString()
                let timeheure = ''

                if(timeText !== '0'){

                    let splitTime = timeText.split('.')

                    if(splitTime.length == 2){
                        if(splitTime[1].length === 1){
                            splitTime[1] = splitTime[1] + '0'
                        }
                    }


                    let min = ''

                    if(Number(splitTime[1]) > 12.5 && Number(splitTime[1]) <= 27.5){
                        min = "15"
                    }else if(Number(splitTime[1]) > 37.5 && Number(splitTime[1]) <= 62.5){
                        min = "30"
                    }else if(Number(splitTime[1]) > 62.5 && Number(splitTime[1]) <= 87.5){
                        min = "45"
                    }else{
                        min = "00"
                    }

                    timeheure = splitTime[0] + 'h' + min
                }else{
                    timeheure = '0h'
                }


                return timeheure

            },

            conversionDate: function(annee, mois, jour){
                if(mois < 10){
                    mois = '0'+mois
                }

                if(jour < 10){
                    jour = '0' + jour
                }

                return annee + '-' + mois + '-' + jour
            },

            conversionDateFRToEN: function(date){
                const regex = /^\d{2}\/\d{2}\/\d{4}/;

                const match = date.match(regex);

                let splitDate = match[0].split("/")
                return splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0]
                
            },

            conversionTimeExacte: function(time){
                let timeText = time.toString()
                let timeheure = ''

                if(timeText !== '0'){

                    let splitTime = timeText.split('.')

                    if(splitTime.length == 2){
                        if(splitTime[1].length === 1){
                            splitTime[1] = splitTime[1] + '0'
                        }
                    }


                    timeheure = splitTime[0] + 'h' + splitTime[1].slice(0, 2)
                }else{
                    timeheure = '0h00'
                }


                return timeheure

            },

            conversionTimeNum: function(heure, minute){
                return Number(heure) + Number(minute) / 60
            },

            conversionTimeEntierNum: function(time){
                let heure = time.split('h')[0]
                let minute = time.split('h')[1]
                return Number(heure) + Number(minute) / 60
            },

            calculDureeTrajet: function(element, item){
                return Math.ceil((Number(element.distance) * 2 / Number(item.vitesse) + 2) * 60 / 15) * 15 / 60
            },

            calculDureeTrajetMinMax(item){
                let mesModeles = functionsFiltres.filterRange(functionsFiltres.filterRange(functionsTris.orderBy(dataBase.modelesavions, 'AZ', 'modele'), 'categorie', 1, functionsTris.orderNumberType(functionsFiltres.filterSome(dataBase.aeroports, 'id', item.destination, 'aeroport'), 'AZ', 'categorie')[0].categorie), 'distance', item.distance, 40075)
                let min = functionsTris.orderNumberType(mesModeles, 'ZA', 'vitesse')[0]
                let max = functionsTris.orderNumberType(mesModeles, 'AZ', 'vitesse')[0]

                let durees = {
                    min: this.calculDureeTrajet(item, min),
                    max: this.calculDureeTrajet(item, max)
                }

                return durees
            },

            calculDureeTrajetSimple: function(element, item){
                return (Number(element.distance) / Number(item.vitesse))
            },

            calculateDuration(element, type, id) {
                let date1 = new Date(element[type].date.year + '-' + element[type].date.month + '-' + element[type].date.day);
                let date2 = new Date(this.date('').date_en);
                tmp = date2 - date1
                var diff = {}							// Initialisation du retour
                var tmp = date2 - date1;

                tmp = Math.floor(tmp/1000);             // Nombre de secondes entre les 2 dates
                diff.sec = tmp % 60;					// Extraction du nombre de secondes

                tmp = Math.floor((tmp-diff.sec)/60);	// Nombre de minutes (partie entière)
                diff.min = tmp % 60;					// Extraction du nombre de minutes

                tmp = Math.floor((tmp-diff.min)/60);	// Nombre d'heures (entières)
                diff.hour = tmp % 24;					// Extraction du nombre d'heures
                
                tmp = Math.floor((tmp-diff.hour)/24);	// Nombre de jours restants
                if(id === 'day'){
                    diff.day = tmp;
                }else{
                    diff.day = tmp % 30;

                    tmp = Math.floor((tmp-diff.day)/30);	// Nombre de jours restants
                    
                    if(id === 'month'){
                        diff.month = tmp;
                    }else{
                        diff.month = tmp % 12;

                        tmp = Math.floor((tmp-diff.month)/12);	// Nombre de jours restants
                        if(id === 'year'){
                            diff.year = tmp;
                        }else{
                            diff.year = tmp % 12;                    
                        }
                    }


                }
                return diff;
            },

            calculHeureFin: function(jour, heure, min, duree, id){
                let dureeSplit = duree.split('h')
                let minA = Number(min) + Number(dureeSplit[1])
                let heureA = Number(heure) + Number(dureeSplit[0])
                let jourA = jour

                if(minA >= 60){
                    minA = minA - 60
                    heureA = heureA + 1
                }

                if(minA === 0){
                    minA = '00'
                }else if(minA < 10){
                    minA = '0' + minA
                }

                if(heureA >= 24){
                    let index = jours.indexOf(jourA) + Math.trunc(heureA / 24)
                    heureA = heureA - 24 * Math.trunc(heureA / 24)
                    if(index >= 7){
                        index = index - 7
                    }
                    jourA = jours[index]
                }
                if(heureA < 10){
                    heureA = '0'+heureA
                }

                let heureF = heureA + 'h' + minA

                let all = {}
                all.day = jourA
                all.heure = heureA
                all.minute = minA

                if(id === 'jour'){
                    return jourA
                }else if(id === 'heure'){
                    return heureF
                }else{
                    return all
                }
            },

            inputDate(date){
                var currentdate = ''
                
                if(date === ''){
                    currentdate = new Date();
                }else{
                    currentdate = new Date(date)
                }
                
                var annee = currentdate.getFullYear();
                var moi = currentdate.getMonth();
                var jour = currentdate.getDay();
                let j = currentdate.getDate()
                if(j < 10){
                    j = '0'+j
                }

                let maDate = {}


                maDate.year = annee
                maDate.month = Number(moisnumerique[moi])
                maDate.day = Number(j)
                maDate.year_fr = annee
                maDate.month_fr = moisnumerique[moi]
                maDate.day_fr = j

                return maDate
            },

            compareDate(date, separateur){
                let dateSplit = date.split(separateur)
                let maDateCompare = ''

                if(separateur === '-'){
                    for(let i = 0; dateSplit.length > i; i++){
                        maDateCompare = maDateCompare + dateSplit[i]
                    }
                }
                return maDateCompare

            },

            structureCalendrierMois(date, jourDefaut, monMois, monAnnee){
                let maDate = this.date(date)
                let jours = []
                let maDateDebutMois = this.getFirstAndLastDayOfMonth(this.date(date).mois, this.date(date).annee, monMois, monAnnee).firstDay
                let maDateFinMois = this.getFirstAndLastDayOfMonth(this.date(date).mois, this.date(date).annee, monMois, monAnnee).lastDay
                let nbrJour = Number(maDateFinMois.slice(8, 10))
                let YYYYMM = maDateDebutMois.slice(0, 8)

                let firstDay = this.date(YYYYMM+ '01').jour
                let indexJour = jours_fr.indexOf(firstDay)
                for(let j = 0; indexJour > j; j++){
                    let journee = {
                        id: this.getDateAnte(YYYYMM+ '01', indexJour - j),
                        date: this.date(this.getDateAnte(YYYYMM+ '01', indexJour - j)).date,
                        jour: this.date(this.getDateAnte(YYYYMM+ '01', indexJour - j)).jour
                    }

                    jours.push(journee)
                }

                for(let j = 1; nbrJour >= j; j++){
                    let jour = ''
                    if(j < 10){
                        jour += YYYYMM + "0" + j
                    }else{
                        jour += YYYYMM + j
                    }

                    let journee = {
                        id: jour,
                        date: this.date(jour).date,
                        jour: this.date(jour).jour
                    }

                    jours.push(journee)
                }

                

                return {calendrier: jours, dateDefaut: this.selectDateDefautCalendrier(jours, jourDefaut)}
            },

            couleurCaseCalendrier(date, dateCompa, dateSelect, max, datesFermeture, listeJoursFerie){
                // console.log(date, dateCompa, dateSelect, max, datesFermeture)
                let result = {
                    classe: '',
                    firstDate: ''
                }

                if(this.date(date).date_compa === dateSelect && this.date(date).date_compa >= dateCompa){
                    result.classe = 'bg-gris-blanc border-vigne'
                }else if(listeJoursFerie.data[this.date(date).date_en] !== undefined){
                    result.classe = 'bg-gris-moyen cursor border-gris-moyen'
                }else if(datesFermeture.includes(this.date(date).date_en)){
                    result.classe = 'bg-gris-fonce border-gris-fonce'
                }else if(this.date(date).date_compa >= dateCompa && max >= 1){
                    result.classe = 'bg-gris-blanc cursor border-gris-blanc'
                    if(result.firstDate === ''){
                        result.firstDate = this.date(date).date_compa
                    }
                }else{
                    result.classe = 'bg-gris-moyen cursor border-gris-moyen'
                }

                return result
            },

            selectDateDefautCalendrier(listeDate, jour){
                let dateSelected = null
                let i = 0
                while(dateSelected === null){
                    if(this.date(listeDate[i].id).date_compa >= this.date('').date_compa && this.date(listeDate[i].id).jour === jour){
                        return dateSelected = listeDate[i].id
                    }else if(this.getFirstAndLastDayOfMonth(this.date(listeDate[i].id).mois, this.date(listeDate[i].id).annee, 0, 0) === listeDate[i].id){
                       return dateSelected = ''
                    }

                    i++
                }
            },

            selectMonthCalendrier(id, date){
                let monMois = date.mois
                let monAnnee = date.annee
                if(id === 'plus'){
                    monMois++
                    if(monMois > 12){
                        monMois = 1
                        monAnnee += 1
                    }
                }else if(id === 'minus'){
                    monMois--
                    if(monMois === 0){
                        monMois = 12
                        monAnnee -= 1
                    }
                }
                
                return {
                    mois: monMois,
                    annee: monAnnee
                }
            },

            prochainJourPrivilegier(dateSelection, jourPrivilegier, datesFermeture){
                const joursSemaine = params.joursSemaineEN
                let result = false
                // Obtenir l'index du jour privilégié
                const indexJourPrivilegier = joursSemaine.indexOf(jourPrivilegier);
                if (indexJourPrivilegier === -1) {
                    throw new Error("Le jour privilégié est invalide.");
                }
                
                // Obtenir le jour actuel (index) à partir de la date sélectionnée
                const dateRef = new Date(dateSelection); // Convertir en objet Date
                // const indexJourActuel = dateRef.getDay(); // 0 = dimanche, 6 = samedi
            
                // Calculer la différence de jours pour atteindre le jour privilégié
                // const joursAAjouter = (indexJourPrivilegier - indexJourActuel + 7) % 7 || 7;
            
                // Ajouter le nombre de jours à la date de référence
                // dateRef.setDate(dateRef.getDate() + joursAAjouter);

                while (true) {
                    const indexJourActuel = dateRef.getDay(); // Index du jour actuel
            
                    // Vérifier si c'est le jour privilégié
                    if (indexJourActuel === indexJourPrivilegier) {
                        const dateISO = dateRef.toISOString().split('T')[0]; // Format AAAA-MM-JJ
            
                        // Vérifier si cette date est dans la liste des jours fermés
                        if (!datesFermeture.includes(dateISO)) {
                            return dateISO; // Retourner la date valide
                        }
                    }
            
                    // Passer au jour suivant
                    dateRef.setDate(dateRef.getDate() + 1);
            
                    // Empêcher une boucle infinie en cas d'erreur logique (optionnel)
                    if (dateRef.getMonth() !== new Date(dateSelection).getMonth() || dateRef.getFullYear() !== new Date(dateSelection).getFullYear()) {
                        throw new Error("Aucun jour privilégié ouvert trouvé dans le mois de la date sélectionnée.");
                    }
                }
            }

            // prochainJourPrivilegier(dateSelection, jourPrivilegier, datesFermeture) {
            //     const joursSemaine = params.joursSemaineEN
                
            //     // Obtenir l'index du jour privilégié
            //     const indexJourPrivilegier = joursSemaine.indexOf(jourPrivilegier);
            //     if (indexJourPrivilegier === -1) {
            //         throw new Error("Le jour privilégié est invalide.");
            //     }
                
            //     // Obtenir le jour actuel (index) à partir de la date sélectionnée
            //     const dateRef = new Date(dateSelection); // Convertir en objet Date
            //     const indexJourActuel = dateRef.getDay(); // 0 = dimanche, 6 = samedi
            
            //     // Calculer la différence de jours pour atteindre le jour privilégié
            //     const joursAAjouter = (indexJourPrivilegier - indexJourActuel + 7) % 7 || 7;
            
            //     // Ajouter le nombre de jours à la date de référence
            //     dateRef.setDate(dateRef.getDate() + joursAAjouter);
            
            //     return dateRef;
            // }
        }

    export default date


// WEBPACK FOOTER //
// ./src/functions/date.js